<template>
  <div class="navHeader">
    <div class="main">
      <a href="" class="logo">{ R }</a>
      <fa :icon="iconClasses" class="fas" @click="toggleIcon" color="white"/>
    </div>
    <nav class="navBar">
      <a @click="scroll('home')" class="navBtn">Home</a>
      <a @click="scroll('projects')" class="navBtn">Projects</a>
      <a @click="scroll('about')" class="navBtn">About</a>
      <a @click="scroll('contact')" class="navBtn">Contact</a>
    </nav>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      icon: ['fas', 'bars'],
      isBarsIcon: true,
    };
  },
  computed: {
    iconClasses() {
      return this.isBarsIcon ? ['fas', 'bars'] : ['fas', 'xmark'];
    },
  },

methods: {
    scroll(refName){
        const element = document.getElementById(refName);
        element.scrollIntoView({behavior: 'smooth'});
    },
    toggleIcon() {
      this.isBarsIcon = !this.isBarsIcon;
      let navBar = document.querySelector('.navBar');
      let head = document.querySelector('.navHeader');
      if(this.isBarsIcon){
        navBar.classList.remove('active');
        head.classList.remove('active');
      }else{
        navBar.classList.add('active');
        head.classList.add('active');
      }
    },
}
}
</script>


  
<style scoped>



.navHeader{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 1.2rem 5%;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.logo{
  font-family: bigover;
  text-decoration: none;
  color: #fff;
}

.navBar{
  display: flex;
  flex-direction: row;
}

.navBar{
  display: flex;
  flex-direction: row;
}

.navBar a{
  display: flex;
  /* flex-direction: row; */
  font-family: 'Poppins';
  font-size: 1.05rem;
  font-weight: 600;
  margin-left: 3rem;
  color: #adabab;;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.3s;
}

a:hover{
  font-weight: 600;
  color: #fff;
  transform: translateY(-5px);
}

.navBar a.active{
  color: #4C55F7;
}

.fas{
  font-size: 1.2rem;
  color: #fff;
  display: none;
}






.v-toolbar-title:hover{
  cursor: pointer;
}

.sections{
  margin-right: 30px;
}

.v-btn{
  font-family: 'Poppins';
  font-weight: bold;
  font-size: medium;
  color: #adabab;
  transition: 0.3s;
  text-transform: capitalize;
}



/* .fas{
  display: none;
} */

@media only screen and (max-width: 600px){
  .fas{
    display: block;
  }

  .sections{
    position: fixed;
    top: 0;
    right: -200px;
    width: 200px;
    height: 100vh;
    padding-top: 50px;
  }

  .sections .navBtn{
    display: block;
    margin: 25px;
  }

  /* .fas{
    position: absolute;
    top: 25px;
    left: 25px;
    cursor: pointer;
  } */
  .fas{
    display: block;
  }

  .navHeader{
    height: max-content;
    display: flex;
    flex-direction: column;
    height: auto;
    /* overflow: hidden; */
    transition: height .5s ease;
  }



  .navHeader.active{
    /* background-color: #151313; */
    height: 250px;
    /* backdrop-filter: blur(8px); */
  }

  @keyframes dropDown {
    from{
      height: max-content;
    }
    to{
      height: 300px;
    }
  }
  
  .navHeader .main{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .navBar{
    transform: translateY(-200%);
    transition: transform .35s ease-in;
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    padding: 1rem 3%;
    z-index: 100;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .navBar.active{
    transform: translateY(0%);
    display: flex;
    flex-direction: column;
  }

  .navBar a:hover{
  font-size: 1.1rem;  
  font-weight: 600;
  color: #fff;
}

  .navBar a{
    display: flex;
    font-size: 1rem;
    margin: .7rem 0;
  }

}

</style>